import React from "react";
import { ExternalLink } from "lucide-react";

const ENTITIES = [
  {
    flag: "🇮🇳",
    role: "Developed by",
    name: "Resilient Sustainance Pvt Ltd",
    domain: "rsustain.com",
    href: "https://rsustain.com",
    desc: "Platform development, engineering, and data science. India's leading ESG systems consultancy.",
    roleLabel: "Development",
  },
  {
    flag: "🇬🇧",
    role: "Technical Governance",
    name: "Resilient Sustainance Ltd",
    domain: "rsustain.co.uk",
    href: "https://rsustain.co.uk",
    desc: "Methodology oversight, assurance standards, and international regulatory alignment.",
    roleLabel: "Governance",
  },
  {
    flag: "🇮🇳",
    role: "Platform Owner & Operator",
    name: "RSustain Carbon Pvt Ltd",
    domain: "rsustain.org",
    href: "https://rsustain.org",
    desc: "Commercial platform operations, access management, and India market delivery.",
    roleLabel: "Operations",
  },
  {
    flag: "🇺🇸",
    role: "Global Network",
    name: "RSustain Global",
    domain: "rsustain.net",
    href: "https://rsustain.net",
    desc: "International partnerships, cross-border ESG advisory, and global carbon markets access.",
    roleLabel: "Global",
  },
  {
    flag: "🇶🇦",
    role: "MENA Partner",
    name: "GSustain",
    domain: "gsustain.org",
    href: "https://gsustain.org",
    desc: "Regional delivery across the Middle East and North Africa. GCC sustainability advisory.",
    roleLabel: "MENA",
  },
];

export default function TrustSection() {
  return (
    <section className="governance-section" id="governance">
      <div className="landing-container">
        <div className="section-label">INSTITUTIONAL BACKING</div>
        <h2 className="section-title">
          Backed by a Global ESG Network
        </h2>
        <p className="section-sub">
          GreenSetu is built, governed, and operated by a multi-entity international
          structure — ensuring methodological rigour, regulatory alignment, and global reach.
        </p>

        <div className="governance-strip">
          {ENTITIES.map((e, i) => (
            <div key={i} className="governance-card">
              <div className="governance-card-top">
                <span className="governance-flag">{e.flag}</span>
                <span className="governance-role-label">{e.roleLabel}</span>
              </div>
              <div className="governance-role">{e.role}</div>
              <div className="governance-name">{e.name}</div>
              <p className="governance-desc">{e.desc}</p>
              <a
                href={e.href}
                target="_blank"
                rel="noopener noreferrer"
                className="governance-link"
              >
                {e.domain}
                <ExternalLink size={11} />
              </a>
            </div>
          ))}
        </div>

        {/* Tagline */}
        <div className="governance-tagline">
          RSustain Advisory Ecosystem — India · United Kingdom · United States · Qatar
        </div>
      </div>
    </section>
  );
}
